module.exports = __webpack_public_path__ + "static/eindruecke1-6c424b56fb5268edb236419ac0b38c0b.jpg";